import { reactive, toRefs } from 'vue'
import { Message } from 'view-design'
import { clone } from '@/common/js/just.js'
import { MEDIAS } from '@/common/js/constants.js'

export function useBatchDateTimeSchedule(selectList) {
  const state = reactive({
    dateTimeModifyModal: false,
    batchModifyDatetimeRows: []
  })

  const showPlanBatchDateTimeScheduleModal = () => {
    if (!selectList.value?.length) return Message.info('请选择至少一个计划！')

    state.dateTimeModifyModal = true

    let rows = clone(selectList.value)

    // 当项目预算修改，标记相同项目的行
    const obj = {}

    // 第一次打开弹窗时，处理表格行显示的投放日期时间数据，
    rows = rows.map((s, index) => {
      const row = {
        ...s,

        retryLoading: false, // 重试按钮loading
        currLaunchDate: [], // 日期类型的开始日期和结束日期
        formatedSchedulesText: '', // 用于表格显示的修改前的时间段
        updateFormatedSchedulesText: '', // 用于表格显示的修改后的时间段
        updateDateValue: '', // 批量修改投放日期表格，接收popover弹窗选择的投放日期值
        updateDateTypeRadio: 0, // 批量修改投放日期表格，接收popover弹窗选择长期投放或具体日期类型

        // 接收修改后的时间段model
        dateTimeResult: {}
      }

      if (s.projectNameForBudget && s.mediaId === MEDIAS.TOUTIAO) {
        const idx = obj[s.projectNameForBudget]
        obj[s.projectNameForBudget] = index + 1

        if (typeof idx === 'number') {
          row.hasSameProject = idx
        }
      }

      return row
    })

    state.batchModifyDatetimeRows = rows
  }

  return {
    ...toRefs(state),
    showPlanBatchDateTimeScheduleModal
  }
}
